<template>
  <div>
    <group-card title="Application Locks" icon="real_estate_agent" padded>
      <div data-app>
        <v-data-table
          :headers="lockHeaders"
          :items="locks"
          item-key="id"
          :items-per-page="10"
          class="elevation-0 application_lock_table"
          :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'first_page',
          lastIcon: 'last_page',
          prevIcon: 'skip_previous',
          nextIcon: 'skip_next'}"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.name="{ item }">
            {{item.name | name}}
          </template>
          <template v-slot:item.actions="{ item }">
            <span>
              <v-icon
                small
                class="mr-2"
                @click="releaseLock(item.loan_application_id)"
              >
                lock_open
              </v-icon>
              <md-tooltip md-direction="top">Release Lock</md-tooltip>
            </span>
          </template>
        </v-data-table>
      </div>
    </group-card>
  </div>
</template>
<script>
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import {mapGetters} from "vuex";

export default {
  components:{
    GroupCard,
  },
  data(){
    return {
      locks: [],
      lockHeaders: [
        {
          text: "Application Id",
          align: 'start',
          sortable: true,
          value: 'loan_application_id'
        },
        {text: 'Full Name', value: 'name'},
        {text: 'Expires At', value: 'expires_at'},
        {text: 'Actions', value: 'actions', sortable: false},
      ]
    }
  },
  methods:{
    async getAppLocks() {
      var response = await this.$store.dispatch('fetch_application_locks');
      if (response) {
        this.locks = this.applicationLocks();
      }
    },
    async releaseLock(loan_application_id) {
      await this.$store.dispatch('release_application_lock', loan_application_id)
      await this.getAppLocks();
    }
  },
  created() {
    this.getAppLocks()
  },
  computed: {
    ...mapGetters({
      applicationLocks: 'applicationLocks',
    }),
  },
  filters: {
    ...filters,
  }
}
</script>
<style lang="scss" scoped>
.application_lock_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}
</style>

